/* Normalize directions in store-managed descriptions, pages, and articles. */
(() => {
  const wording = 'Take two capsules daily, preferably with a meal or snack, or as directed by your healthcare professional.';
  const pattern = /take (?:two|2) capsules daily with food,?\s+or as directed by your healthcare professional\./gi;
  const scan = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement?.closest('script,style,textarea,input,[contenteditable="true"]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while ((node = walker.nextNode())) {
      const changed = node.nodeValue.replace(pattern, wording);
      if (changed !== node.nodeValue) node.nodeValue = changed;
    }
  };
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
